/* eslint-disable import/no-extraneous-dependencies */
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Popup from 'modules/common/components/Popup';
import {
  PopupTitleSpan,
  PopupWrapper,
  PopupTitle,
  PopupTitleWrapper,
  Container,
  PopupTitleContainer,
  DoctorImage,
  DoctorName,
} from './DoctorInfoModal.style';

const DoctorInfoModal = ({ onClose, providerInfo }) => {
  const areas = useSelector(state => state.categories.dropdownsList.areasList);

  const { providerName, providerPhoto, areaKey } = providerInfo;
  const providerArea = areas?.find(area => area.key === areaKey);
  const providerNameAndArea = `${providerName} - ${providerArea?.name}`;
  const onClickClose = () => {
    onClose();
  };

  return (
    <Popup showCloseBtn={false}>
      <PopupWrapper>
        <PopupTitleContainer>
          <PopupTitleWrapper>
            <PopupTitle>Doctor</PopupTitle>
            <PopupTitleSpan
              onClick={() => {
                onClickClose();
              }}
            />
          </PopupTitleWrapper>
        </PopupTitleContainer>

        <Container>
          <div
            style={{
              height: 'fit-content',
              width: '680px',
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              padding: '16px',
            }}
          >
            <DoctorImage src={providerPhoto} alt="provider-image" />
            <DoctorName>{providerNameAndArea}</DoctorName>
          </div>
        </Container>
      </PopupWrapper>
    </Popup>
  );
};

DoctorInfoModal.propTypes = {
  onClose: PropTypes.func,
};

export default DoctorInfoModal;
